import { FC, SVGAttributes } from "react";

const StepperArrow: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 24,
  height = 8,
  stroke = "currentColor",
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M0 4H23M23 4L19.5 1M23 4L19.5 7"
      stroke={stroke}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { StepperArrow };
